import GA from 'react-ga4';

GA.initialize('G-F5ZMZ95B55');

export { GA }